export default __webpack_public_path__ + "static/kursk-cf7a2060cf71c3c4ef6c187dc62a16e0.webp";